// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import { FEEDS_ADD_FEED } from './constants';

export function addFeed(feed) {
  return {
    type: FEEDS_ADD_FEED,
    data: feed,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case FEEDS_ADD_FEED:
      return {
        ...state,
        news: state.news.withMutations(news => {
          let isExist = news.find(n => n.id === action.data.id);
          return !isExist ? news.push(action.data) : null;
        }),
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/feeds/redux/addFeed.js